


























































































import Vue from "vue";
import moment from "moment";

// Model
import { formatCurrency } from "@/utility/Formatter";
import { Transaction } from "@/model/data/cashFlow/Transaction";
import { mapGetters } from "vuex";
import { GetIntegrationFeedbackResultEnumLabel, IntegrationFeedbackResultEnum } from "@/model/data/cashFlow/IntegrationFeedback";
import { TransactionTypeEnum } from "@/model/data/enums/TransactionTypeEnum";

export default Vue.extend({
    data() {
        return {
            IntegrationFeedbackResultEnum,
            noContentTransactions: [TransactionTypeEnum.ManualEmpty, TransactionTypeEnum.ManualDeposit, TransactionTypeEnum.EndDay, TransactionTypeEnum.UserBalance],
            virtualSafeTransactions: [TransactionTypeEnum.VirtualSafeDeposit, TransactionTypeEnum.VirtualSafeWithdrawal],
        };
    },
    props: {
        transaction: { required: true, type: Transaction },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        notPaidChange() {
            if (this.transaction.extraFeatures && this.transaction.extraFeatures.notPaidChange) return JSON.parse(this.transaction.extraFeatures.notPaidChange);
            return null;
        },
        paymentsExpectedAmount() {
            if (this.transaction.extraFeatures && this.transaction.extraFeatures.paymentsExpectedAmount) return JSON.parse(this.transaction.extraFeatures.paymentsExpectedAmount);
            return null;
        },
        fields() {
            return [
                // { id: "Id", i18n: "common.id" },
                {
                    id: "dateTime",
                    i18n: "common.date",
                    process: (v) => moment(v).format(this.longDateFormat(true, true, true)),
                },
                {
                    id: "accountingDate",
                    i18n: "common.accounting_date",
                    process: (v) => moment(v).format(this.longDateFormat(false, true, true)),
                },
                { id: "nop", i18n: "common.transactionId" },
                {
                    id: "userName",
                    i18n: "common.username",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "userId",
                    i18n: "common.userId",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "userAlternateId",
                    i18n: "common.username_alternate",
                    condition: (v) => v && v.length > 0,
                },

                {
                    id: "channelId",
                    i18n: "common.channel",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "shiftNumber",
                    i18n: "common.shift_number",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "customerCode",
                    i18n: "common.customer_code",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "bagId",
                    i18n: "common.bag_id",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "info",
                    i18n: "common.info",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "transactionRef",
                    i18n: "cash_report.transaction_ref",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "userInfo",
                    i18n: "cash_report.user_info",
                    condition: (v) => v && v.length > 0 && v.length < 128,
                },
                {
                    id: "userOrganization",
                    i18n: "cash_report.user_organization",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "groupName",
                    i18n: "cash_report.groupName",
                    condition: (v) => v && v.length > 0,
                },
                {
                    id: "executorUserId",
                    i18n: "cash_report.executorUserId",
                    condition: (v) => v && v.length > 0,
                },
            ];
        },
        showEnvelopeId() {
            return this.transaction.type == TransactionTypeEnum.ManualDeposit && this.transaction.envelopesInfo && this.transaction.envelopesInfo.length;
        },
    },
    methods: { formatCurrency, GetIntegrationFeedbackResultEnumLabel },
});
